/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClassCalendarItem } from './ClassCalendarItem';
import {
    ClassCalendarItemFromJSON,
    ClassCalendarItemFromJSONTyped,
    ClassCalendarItemToJSON,
    ClassCalendarItemToJSONTyped,
} from './ClassCalendarItem';

/**
 * 
 * @export
 * @interface WidgetDataClassesCalendarWidgetData
 */
export interface WidgetDataClassesCalendarWidgetData {
    /**
     * 
     * @type {string}
     * @memberof WidgetDataClassesCalendarWidgetData
     */
    $type?: WidgetDataClassesCalendarWidgetDataTypeEnum;
    /**
     * 
     * @type {Array<ClassCalendarItem>}
     * @memberof WidgetDataClassesCalendarWidgetData
     */
    items: Array<ClassCalendarItem>;
}


/**
 * @export
 */
export const WidgetDataClassesCalendarWidgetDataTypeEnum = {
    ClassesCalendar: 'classes-calendar'
} as const;
export type WidgetDataClassesCalendarWidgetDataTypeEnum = typeof WidgetDataClassesCalendarWidgetDataTypeEnum[keyof typeof WidgetDataClassesCalendarWidgetDataTypeEnum];


/**
 * Check if a given object implements the WidgetDataClassesCalendarWidgetData interface.
 */
export function instanceOfWidgetDataClassesCalendarWidgetData(value: object): value is WidgetDataClassesCalendarWidgetData {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function WidgetDataClassesCalendarWidgetDataFromJSON(json: any): WidgetDataClassesCalendarWidgetData {
    return WidgetDataClassesCalendarWidgetDataFromJSONTyped(json, false);
}

export function WidgetDataClassesCalendarWidgetDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetDataClassesCalendarWidgetData {
    if (json == null) {
        return json;
    }
    return {
        
        '$type': json['$type'] == null ? undefined : json['$type'],
        'items': ((json['items'] as Array<any>).map(ClassCalendarItemFromJSON)),
    };
}

export function WidgetDataClassesCalendarWidgetDataToJSON(json: any): WidgetDataClassesCalendarWidgetData {
    return WidgetDataClassesCalendarWidgetDataToJSONTyped(json, false);
}

export function WidgetDataClassesCalendarWidgetDataToJSONTyped(value?: WidgetDataClassesCalendarWidgetData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        '$type': value['$type'],
        'items': ((value['items'] as Array<any>).map(ClassCalendarItemToJSON)),
    };
}

